import { ApolloCache, gql } from '@apollo/client';
import { LoginMutation } from '../__generated__/graphql';

export const GET_ME = gql(/*GraphQL*/ `
 query GetMe {
    getMe {
        id
        email
        name
        role
        isVerified
        hasFingerprint
        isValidFingerprint
        isGoogleAuth
        planExpiresAt
        planName
        }
    }`);

export const updateCacheGetMe = (
  cache: ApolloCache<any>,
  login: LoginMutation,
) => {
  cache.modify({
    fields: {
      me() {
        const newUserRef = cache.writeFragment({
          data: login,
          fragment: gql`
            fragment NewUser on User {
              id
              email
              name
              planExpiresAt 
              planName
            }
          `,
        });
        return newUserRef;
      },
    },
  });
};
